// return true if the browser is safari
export default (() => /constructor/i.test(window.HTMLElement)
  || (function s(p) {
    return p.toString() === '[object SafariRemoteNotification]';
  }(
    !window.safari || (typeof safari !== 'undefined' && safari.pushNotification),
  )))();
